// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1UNWW","right":"styles_right__2vvUm"};